<!-- 
  Everytime user visit this page, it will log the user out and
  redirect user to the login page with the same search parameters.
  It is useful when a user from subdomain need to log out and then
  redirect back to the previous site if needed.
 -->
<script lang="ts">
  import { onMount } from "svelte";
  import { setHeadTitle } from "../../app/store/store-ui";
  import { signOut } from "../../app/api";
  import { isLoggedIn, isCurrentUserLoaded } from "../../app/store/store-user";
  import pageUrl from "../../PageUrl";

  onMount(() => {
    setHeadTitle("Log out");
    return () => setHeadTitle("");
  });

  signOut();

  $: if ($isCurrentUserLoaded && !$isLoggedIn) {
    const url = new URL(location.toString());
    url.pathname = pageUrl.SIGNIN;
    location.replace(url.toString());
  }
</script>
